/**
 * API endpoints for leaderboards
 */
export class LeaderboardsAPI {
    apiClient;
    controllerUrl;
    /**
     * Create a new LeaderboardsAPI
     * @param apiClient - The API client
     * @param baseUrl - The base URL for API requests
     */
    constructor(apiClient, baseUrl) {
        this.apiClient = apiClient;
        this.controllerUrl = `${baseUrl}/Leaderboards`;
    }
    /**
     * Get leaderboard
     * @param params - Query parameters
     * @returns Promise with the leaderboard
     */
    async get(params = {}) {
        return this.apiClient.get(this.controllerUrl, params);
    }
    /**
     * Get rating leaderboard
     * @param options - Options for the request
     * @returns Promise with the ratings
     */
    async getRatings({ course, limit }) {
        const url = "/ratings";
        return this.apiClient.get(this.controllerUrl + url, { course, limit });
    }
    /**
     * Add leaderboard points
     * @param matchId - The match ID
     * @param player - The player
     * @param score - The score
     * @param result - The result
     * @param moves - The number of moves
     * @returns Promise with the result
     */
    async postLeaderboardPoints(matchId, player, score, result, moves) {
        console.log("postLeaderboardPoints", player.user_id, score, result, moves);
        if (!player.user_id)
            return null;
        let points = 0;
        if (score === 1)
            points = 300;
        else if (score === 0)
            points = moves;
        else if (score === 0.5) {
            if (result === "draw by agreement")
                points = Math.min(200, moves * 3);
            else
                points = 200;
        }
        if (points === 0)
            return;
        const url = `/${player.user_id}/points`;
        return this.apiClient.post(this.controllerUrl + url, {
            GameId: matchId,
            UserId: player.user_id,
            PlayerId: player.username,
            Type: "live",
            Points: points,
            CreatedDate: new Date().toISOString(),
        });
    }
}
